<template>
  <div ref="editorWrapper">
    <ckeditor
      v-if="!userIsLoading"
      :editor="editor"
      v-model="user.option.blocnote"
      :config="editorConfig"
      @ready="onReady"
    />
  </div>
</template>

<script>
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DocumentEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "@ckeditor/ckeditor5-build-decoupled-document/build/translations/fr";

import { mapGetters } from "vuex";

export default {
  name: "MyBlocNote",
  data() {
    return {
      editor: DocumentEditor,
      editorConfig: {
        language: "fr",
        shouldNotGroupWhenFull: true,
        toolbar: {
          items: [
            "heading",
            "alignment",
            "|",
            "bold",
            "italic",
            "strikethrough",
            "underline",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "link",
            "|",
            "fontfamily",
            "fontsize",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "insertTable",
            "|",
            "undo",
            "redo",
          ],
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      userIsLoading: "user/current/isLoading",
      user: "user/current/retrieved",
    }),
  },
  methods: {
    onReady(editor) {
      this.$refs.editorWrapper.prepend(editor.ui.view.toolbar.element);
    },
  },
};
</script>

<style scoped></style>
